/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SubscriptionTable from "../../../Tables/Subscription";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import { connect } from "react-redux";
import {
  exportSubscription,
  subscriptionList,
} from "../../../../stores/actions/subscription.actions.types";
import {
  sortingEmailList,
  subscriptionType,
  subscriptioType,
} from "../../../../utilities/enums";
import { BiLoaderAlt } from "react-icons/bi";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import Paginations from "../../../Common/Pagination";

const SubscriptionList = ({
  subscriptionList,
  exportSubscription,
  loading,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [subscriptions, setSubscriptions] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [type, setType] = useState({});
  const [sorting, setSorting] = useState([
    {
      whom: "createdAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getSubscriptionList();
  }, [search, sorting, pagination.page, type]);

  const getSubscriptionList = () => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, subscriptions } = data?.data;
        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));
        setSubscriptions(subscriptions);
      }
    };

    let request = {
      callback,
      data: { email: search, page: pagination.page, sort: sorting, ...type },
    };
    subscriptionList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  const handleChangeType = (value) => {
    const typeFilter = JSON.parse(value);
    setType(typeFilter);
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handleExport = async () => {
    setExportLoading(true);
    const callback = () => {
      setExportLoading(false);
    };
    exportSubscription({ callback });
  };

  return (
    <div>
      <MetaHead title={t("subscription-list")} />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          placeholder='Search by email'
          search={search}
          setSearch={setSearch}
        />
        <Sorting
          name={"Sort"}
          values={sortingEmailList}
          onChange={handleChangeSorting}
        />
        <Sorting
          name={"Type"}
          values={subscriptionType}
          onChange={handleChangeType}
        />
        <div className='  text-end'>
          <button
            className=' w-[100px] inline-block rounded-md bg-red-600 px-4 py-1 text-white'
            onClick={handleExport}
          >
            {exportLoading ? (
              <BiLoaderAlt className='animate-spin text-2xl m-auto  text-white' />
            ) : (
              "Export"
            )}
          </button>
        </div>
      </div>
      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : subscriptions?.length ? (
        <SubscriptionTable
          subscriptions={subscriptions}
          setSubscriptions={setSubscriptions}
        />
      ) : (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}

      <Paginations pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  subscriptionList,
  exportSubscription,
})(SubscriptionList);
